import React from "react";

import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Typography,
} from "@mui/material";

import { HelpBox } from "@/components/atoms";
import { Activation, ActivationStatus } from "@/types";
import {
  activationStatusColorMap,
  activationStatusDescription,
  isActivationExpired,
  renderDateRange,
} from "@/utils";

interface ActivationCardProps {
  activation: Activation;
  onEdit: (activation: Activation) => void;
}

const ActivationCard: React.FC<ActivationCardProps> = ({
  activation,
  onEdit,
}) => {
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        width: "220px",
        height: "200px",
      }}
    >
      <CardActionArea onClick={() => onEdit(activation)}>
        <CardContent
          sx={{
            height: "152px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            alignItems: "center",
            pb: 0,
            "&:last-child": { pb: 0 },
          }}
        >
          <Typography
            variant="h6"
            textAlign="center"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "2",
              WebkitBoxOrient: "vertical",
            }}
          >
            {activation.campaign_name}
          </Typography>
          <Box display="flex" flexDirection="column" alignItems="center">
            <Typography variant="body2" color="textSecondary">
              {activation.platform}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {`${activation.audiences.length} Segment${activation.audiences.length > 1 ? "s" : ""}`}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {renderDateRange(
                activation.campaign_date_start,
                activation.campaign_date_end,
              )}
            </Typography>
          </Box>
        </CardContent>
      </CardActionArea>
      <CardActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          pl: 2,
        }}
      >
        <HelpBox
          title={
            activationStatusDescription[
              (isActivationExpired(activation)
                ? "complete"
                : activation.status) as ActivationStatus
            ]
          }
          placement="bottom"
        >
          <Typography
            variant="body2"
            color={
              activationStatusColorMap[
                (isActivationExpired(activation)
                  ? "complete"
                  : activation.status) as ActivationStatus
              ]
            }
            sx={{
              fontWeight: 700,
              textTransform: "uppercase",
            }}
          >
            {isActivationExpired(activation) ? "complete" : activation.status}
          </Typography>
        </HelpBox>
        <Button
          size="small"
          variant="contained"
          onClick={() => onEdit(activation)}
        >
          View
        </Button>
      </CardActions>
    </Card>
  );
};

export default ActivationCard;
